import {
	isRouteErrorResponse,
	Navigate,
	useLocation,
	useRouteError,
} from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ServerErrorAlert from 'src/components/ui/ServerErrorAlert';
import { buildNoAccessPath } from './constants';
import { isUnauthorizedError } from 'src/utils/helpers/isUnauthorizedError';

const ErrorBoundary = () => {
	const error = useRouteError();
	const location = useLocation();

	if (
		isUnauthorizedError(error) ||
		(isRouteErrorResponse(error) && error.status === 401)
	) {
		return <Navigate to={buildNoAccessPath(location)} replace />;
	}

	const displayError = isRouteErrorResponse(error)
		? {
				message: `${error.status} ${error.statusText}`,
				debugMessage:
					error.data?.debugMessage ||
					error.error?.debugMessage ||
					null,
			}
		: error;

	return (
		<Stack spacing={2} sx={{ p: 4, maxWidth: 960 }}>
			<Typography variant="h3">Unexpected Application Error!</Typography>
			<Box>
				<ServerErrorAlert error={displayError} />
			</Box>
		</Stack>
	);
};

export default ErrorBoundary;
